/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CellValue } from './CellValue';
import {
    CellValueFromJSON,
    CellValueFromJSONTyped,
    CellValueToJSON,
    CellValueToJSONTyped,
} from './CellValue';

/**
 * 
 * @export
 * @interface PianoAssenzeMensile
 */
export interface PianoAssenzeMensile {
    /**
     * 
     * @type {number}
     * @memberof PianoAssenzeMensile
     */
    idPersonale?: number;
    /**
     * 
     * @type {string}
     * @memberof PianoAssenzeMensile
     */
    nominativo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PianoAssenzeMensile
     */
    azienda?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PianoAssenzeMensile
     */
    mese?: number;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell1?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell2?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell3?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell4?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell5?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell6?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell7?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell8?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell9?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell10?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell11?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell12?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell13?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell14?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell15?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell16?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell17?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell18?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell19?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell20?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell21?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell22?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell23?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell24?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell25?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell26?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell27?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell28?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell29?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell30?: CellValue;
    /**
     * 
     * @type {CellValue}
     * @memberof PianoAssenzeMensile
     */
    cell31?: CellValue;
}

/**
 * Check if a given object implements the PianoAssenzeMensile interface.
 */
export function instanceOfPianoAssenzeMensile(value: object): value is PianoAssenzeMensile {
    return true;
}

export function PianoAssenzeMensileFromJSON(json: any): PianoAssenzeMensile {
    return PianoAssenzeMensileFromJSONTyped(json, false);
}

export function PianoAssenzeMensileFromJSONTyped(json: any, ignoreDiscriminator: boolean): PianoAssenzeMensile {
    if (json == null) {
        return json;
    }
    return {
        
        'idPersonale': json['idPersonale'] == null ? undefined : json['idPersonale'],
        'nominativo': json['nominativo'] == null ? undefined : json['nominativo'],
        'azienda': json['azienda'] == null ? undefined : json['azienda'],
        'mese': json['mese'] == null ? undefined : json['mese'],
        'cell1': json['cell1'] == null ? undefined : CellValueFromJSON(json['cell1']),
        'cell2': json['cell2'] == null ? undefined : CellValueFromJSON(json['cell2']),
        'cell3': json['cell3'] == null ? undefined : CellValueFromJSON(json['cell3']),
        'cell4': json['cell4'] == null ? undefined : CellValueFromJSON(json['cell4']),
        'cell5': json['cell5'] == null ? undefined : CellValueFromJSON(json['cell5']),
        'cell6': json['cell6'] == null ? undefined : CellValueFromJSON(json['cell6']),
        'cell7': json['cell7'] == null ? undefined : CellValueFromJSON(json['cell7']),
        'cell8': json['cell8'] == null ? undefined : CellValueFromJSON(json['cell8']),
        'cell9': json['cell9'] == null ? undefined : CellValueFromJSON(json['cell9']),
        'cell10': json['cell10'] == null ? undefined : CellValueFromJSON(json['cell10']),
        'cell11': json['cell11'] == null ? undefined : CellValueFromJSON(json['cell11']),
        'cell12': json['cell12'] == null ? undefined : CellValueFromJSON(json['cell12']),
        'cell13': json['cell13'] == null ? undefined : CellValueFromJSON(json['cell13']),
        'cell14': json['cell14'] == null ? undefined : CellValueFromJSON(json['cell14']),
        'cell15': json['cell15'] == null ? undefined : CellValueFromJSON(json['cell15']),
        'cell16': json['cell16'] == null ? undefined : CellValueFromJSON(json['cell16']),
        'cell17': json['cell17'] == null ? undefined : CellValueFromJSON(json['cell17']),
        'cell18': json['cell18'] == null ? undefined : CellValueFromJSON(json['cell18']),
        'cell19': json['cell19'] == null ? undefined : CellValueFromJSON(json['cell19']),
        'cell20': json['cell20'] == null ? undefined : CellValueFromJSON(json['cell20']),
        'cell21': json['cell21'] == null ? undefined : CellValueFromJSON(json['cell21']),
        'cell22': json['cell22'] == null ? undefined : CellValueFromJSON(json['cell22']),
        'cell23': json['cell23'] == null ? undefined : CellValueFromJSON(json['cell23']),
        'cell24': json['cell24'] == null ? undefined : CellValueFromJSON(json['cell24']),
        'cell25': json['cell25'] == null ? undefined : CellValueFromJSON(json['cell25']),
        'cell26': json['cell26'] == null ? undefined : CellValueFromJSON(json['cell26']),
        'cell27': json['cell27'] == null ? undefined : CellValueFromJSON(json['cell27']),
        'cell28': json['cell28'] == null ? undefined : CellValueFromJSON(json['cell28']),
        'cell29': json['cell29'] == null ? undefined : CellValueFromJSON(json['cell29']),
        'cell30': json['cell30'] == null ? undefined : CellValueFromJSON(json['cell30']),
        'cell31': json['cell31'] == null ? undefined : CellValueFromJSON(json['cell31']),
    };
}

export function PianoAssenzeMensileToJSON(json: any): PianoAssenzeMensile {
    return PianoAssenzeMensileToJSONTyped(json, false);
}

export function PianoAssenzeMensileToJSONTyped(value?: PianoAssenzeMensile | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'idPersonale': value['idPersonale'],
        'nominativo': value['nominativo'],
        'azienda': value['azienda'],
        'mese': value['mese'],
        'cell1': CellValueToJSON(value['cell1']),
        'cell2': CellValueToJSON(value['cell2']),
        'cell3': CellValueToJSON(value['cell3']),
        'cell4': CellValueToJSON(value['cell4']),
        'cell5': CellValueToJSON(value['cell5']),
        'cell6': CellValueToJSON(value['cell6']),
        'cell7': CellValueToJSON(value['cell7']),
        'cell8': CellValueToJSON(value['cell8']),
        'cell9': CellValueToJSON(value['cell9']),
        'cell10': CellValueToJSON(value['cell10']),
        'cell11': CellValueToJSON(value['cell11']),
        'cell12': CellValueToJSON(value['cell12']),
        'cell13': CellValueToJSON(value['cell13']),
        'cell14': CellValueToJSON(value['cell14']),
        'cell15': CellValueToJSON(value['cell15']),
        'cell16': CellValueToJSON(value['cell16']),
        'cell17': CellValueToJSON(value['cell17']),
        'cell18': CellValueToJSON(value['cell18']),
        'cell19': CellValueToJSON(value['cell19']),
        'cell20': CellValueToJSON(value['cell20']),
        'cell21': CellValueToJSON(value['cell21']),
        'cell22': CellValueToJSON(value['cell22']),
        'cell23': CellValueToJSON(value['cell23']),
        'cell24': CellValueToJSON(value['cell24']),
        'cell25': CellValueToJSON(value['cell25']),
        'cell26': CellValueToJSON(value['cell26']),
        'cell27': CellValueToJSON(value['cell27']),
        'cell28': CellValueToJSON(value['cell28']),
        'cell29': CellValueToJSON(value['cell29']),
        'cell30': CellValueToJSON(value['cell30']),
        'cell31': CellValueToJSON(value['cell31']),
    };
}

